import { render, staticRenderFns } from "./RegisterAttendanceModal.vue?vue&type=template&id=2bd77810"
import script from "./RegisterAttendanceModal.vue?vue&type=script&lang=js"
export * from "./RegisterAttendanceModal.vue?vue&type=script&lang=js"
import style0 from "./RegisterAttendanceModal.vue?vue&type=style&index=0&id=2bd77810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports